import PropTypes from 'prop-types';

const widthProp = PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['natural', 'even'])]);
export default PropTypes.oneOfType([
  widthProp,
  PropTypes.string,
  PropTypes.shape({
    xs: widthProp,
    sm: widthProp,
    md: widthProp,
    lg: widthProp,
    xl: widthProp
  })
]);
